import type { AppItem } from '@/lib/types/marketplace'
import apiClient from "@/lib/api/client";
import API from "@/api/API";

export const marketplaceApi = {
  list: async (params?: { q?: string; category?: string }) => {
    const response = await apiClient.get<AppItem[]>(API.marketplace.list, { params })
    return response.data
  },
}
